export default "__VITE_ASSET__8f0a4c18__"